const en = {
  brand: {
    name: "OnHuman HR",
    short: "OnHuman",
    tagline: "Human Resources Consulting",
  },
  nav: {
    home: "Home",
    about: "About",
    services: "Services",
    contact: "Contact",
    navigator: "Navigator",
    login: "Sign in",
    logout: "Sign out",
  },
  lang: { tr: "TR", en: "EN" },
  anamenu: {
    hero: {
      title: "Build the future with strategic human resources.",
      keyword: "future",
      body: "OnHuman leads organizational transformation with modern HR solutions. Years of experience put to work transforming your workforce.",
      primaryCta: "Get Consulting",
      secondaryCta: "Our Services",
    },
    capabilities: {
      eyebrow: "What We Do",
      title: "Four core areas of expertise.",
      items: [
        { n: "01", title: "Hiring Strategy", body: "Recruitment that defines your need precisely, respects sector dynamics, and delivers long-term fit. End-to-end management from role analysis to reference checks." },
        { n: "02", title: "Executive Search", body: "Confidential, targeted candidate evaluation for senior roles. Cultural and strategic alignment of your leaders is our priority." },
        { n: "03", title: "Organizational Development", body: "Consulting on structure, process and culture transformation. Build a sustainable workforce with performance management, career mapping, and competency models." },
        { n: "04", title: "Candidate Coaching", body: "Career planning, CV optimization and interview preparation. Individual guidance to help candidates realize their potential in the right roles." },
      ],
    },
    services: {
      eyebrow: "Services",
      title: "Two paths for employers and candidates.",
      cards: [
        { title: "Employer Services", body: "Role analysis, candidate pool management, interview processes and post-placement follow-up. We help shape your company's growth.", href: "/isverenhizmetlerim", cta: "Details" },
        { title: "Candidate Services", body: "Career consulting, CV review, interview coaching and personal brand development. We are with you on the way to your goal.", href: "/adayhizmetlerim", cta: "Details" },
      ],
    },
    cta: {
      title: "Contact Us",
      body: "Get in touch with us for your questions and partnership inquiries.",
      button: "Get in Touch",
      email: "contact@onhumanresources.com",
    },
  },
  // Structural labels for the record layout. These name parts of the page —
  // they carry no claims of their own.
  record: {
    details: "Details",
    related: "Related Pages",
    location: "Location",
    locationValue: "Istanbul · Türkiye",
    email: "Email",
    linkedin: "LinkedIn",
    onThisPage: "On This Page",
    channels: "Contact Channels",
    writeToUs: "Write to Us",
    assistant: "Digital Assistant",
  },
  pages: {
    hakkimda: {
      title: "About",
      p1: "OnHuman brings an ethical, solution-oriented and innovative vision to the field of human resources.",
      p2: "Mutual trust, transparency and confidentiality come first in our consulting processes. We aim to make every organization's human capital stronger, more sustainable and ready for the future. We are here to make a difference in the business world of tomorrow.",
    },
    hizmetler: {
      title: "Our Services",
      lede: "At OnHuman we offer dedicated services to both employers and candidates. We make the right matches for you.",
      cards: [
        { title: "Employer Services", body: "Finding the right talent is the key to your business success. We offer tailored hiring strategies, candidate assessment solutions and consulting services.", href: "/isverenhizmetlerim", cta: "Learn More" },
        { title: "Candidate Services", body: "Ready to take the next step in your career? We are with you with CV consulting, interview preparation and job matching support.", href: "/adayhizmetlerim", cta: "Learn More" },
      ],
      contactLead: {
        title: "Would you like to know more?",
        body: "Fill in our contact form and we will get back to you as soon as possible.",
      },
    },
    ilkeler: {
      title: "Our Working Principles",
      lede: "At OnHuman, our values define the way we work. We listen, understand, and produce the solutions that fit best.",
      values: [
        { title: "Trust and Honesty", body: "Open communication and mutual trust are our cornerstone in business relationships. Transparency is fundamental to all our consulting processes." },
        { title: "Innovation", body: "We stay open to new technologies and approaches to keep up with the ever-evolving world of human resources." },
        { title: "Confidentiality", body: "Our clients' and candidates' information is confidential to us. Data security comes first in every process." },
        { title: "People First", body: "People are at the heart of HR. We focus on bringing out the best of every individual's potential." },
      ],
      contactLead: {
        title: "Would you like to get to know our principles?",
        body: "Get in touch with us to learn more about how we work.",
      },
    },
  },
  forms: {
    contactBand: {
      title: ["Get in touch", "with us"],
      body: "You can reach us with your questions at any time. You can also ask Assistant HR right away.",
      button: "Ask Assistant HR",
    },
    contact: {
      name: "Full name",
      email: "Email",
      message: "Write your message...",
      send: "Send",
      sending: "Sending...",
      fillAll: "Please fill in all fields.",
      invalidEmail: "Please enter a valid email address.",
      sent: "Your message was sent.",
      failed: "Something went wrong while sending the form.",
    },
  },
  candidate: {
    title: "Candidate Details",
    lede: "Please fill in the form below completely to submit your application.",
    fullName: "Full name",
    fullNamePh: "Enter your first and last name",
    email: "Email",
    emailPh: "name@example.com",
    phone: "Phone",
    phonePh: "5XXXXXXXXX",
    sectionEducation: "Education & Skills",
    sectionCv: "CV Upload",
    sectionKvkk: "Data Protection (KVKK)",
    cvLabel: "Upload CV",
    kvkkText: "I have read and accept the KVKK privacy notice.",
    kvkkRead: "Read the notice",
    submit: "Submit application",
    submitting: "Submitting...",
    success: "Your application was sent successfully! 🎉",
    failure: "Something went wrong while sending your application.",
    errors: {
      fullName: "Full name is required.",
      email: "Please enter a valid email address.",
      phone: "Please enter a valid phone number.",
      education: "Please select your education level.",
      cv: "Uploading a CV is required.",
      kvkk: "You must accept the KVKK notice.",
      cvType: "Only PDF, DOC or DOCX files can be uploaded.",
      cvSize: "The file size cannot exceed 5MB.",
    },
    education: {
      label: "Education",
      placeholder: "Select",
      options: [
        { value: "ortaokul", label: "Middle school" },
        { value: "lise", label: "High school" },
        { value: "onlisans", label: "Associate degree" },
        { value: "lisans", label: "Bachelor's degree" },
        { value: "yukseklisans", label: "Master's degree" },
        { value: "doktora", label: "Doctorate" },
      ],
    },
    skills: {
      label: "Skills",
      placeholder: "Add a skill and press comma...",
      hint: "Add skills with a comma or Enter, remove them with ✕.",
    },
  },
  employer: {
    title: "Employer Services",
    lede: "Please fill in the form below completely to submit your request.",
    serviceLabel: "Select a service",
    servicePlaceholder: "Select a service...",
    // `value` is the canonical Turkish name the API and the ?service= links
    // use; only the label changes with the language.
    services: [
      { value: "İşe alım ve Seçme-Yerleştirme Danışmanlığı", label: "Recruitment, selection and placement consulting" },
      { value: "İnsan Kaynakları Süreçlerinin Yapılandırılması", label: "Structuring HR processes" },
      { value: "İK Mevzuatına Uygunluk ve Yasal Süreç Danışmanlığı", label: "HR regulatory compliance and legal process consulting" },
      { value: "Organizasyonel Yapı ve Görev Tanımlarının Oluşturulması", label: "Organizational structure and job descriptions" },
      { value: "Eğitim ve Gelişim Programlarının Tasarımı", label: "Design of training and development programs" },
      { value: "İş Hukuku Süreçlerinde Danışmanlık(Disiplin, Fesih, Uyarı)", label: "Labor law process consulting (discipline, termination, warnings)" },
    ],
    messageLabel: "Your request in detail",
    messagePh: "Please describe your request in detail...",
    submit: "Send request",
    submitting: "Sending...",
    success: "Your request was sent successfully! 🎉",
    failure: "Something went wrong while sending your request.",
    errors: {
      service: "Please select a service.",
      message: "Please describe your request.",
    },
  },
  login: {
    username: "Username",
    usernamePh: "Your username",
    password: "Password",
    remember: "Remember me",
    submit: "Sign in",
    submitting: "Signing in...",
    failed: "Sign-in failed. Please check your details.",
  },
  kvkk: {
    title: "KVKK Privacy Notice",
    p1: "At OnHuman we process your personal data under Turkey's Personal Data Protection Law No. 6698 (\"KVKK\"). Your personal data is collected solely to evaluate your job application and will not be used for any other purpose.",
    p2: "You can contact us to exercise your rights regarding your personal data. For details, please see our KVKK policy.",
    p3: "Your data will only be accessible to authorised staff during the application process and will be processed in line with our legal obligations.",
    close: "Close",
  },
  assistant: {
    eyebrow: "Digital Assistant",
    title: "OnHuman Digital Assistant",
    body: "Ask what you're wondering and get an instant answer. From working hours to the scope of our services, every detail is at hand.",
    panelTitle: "OnHuman Digital Assistant",
    logLabel: "Chat history",
    inputLabel: "Type a question",
    placeholder: "Type a question...",
    send: "Send",
    faqTitle: "Frequently asked",
    greeting: "Hello! How can I help you?",
  },
  dashboard: {
    tabs: {
      user: "Contact Form",
      employer: "Employer Requests",
      candidate: "Candidate Applications",
    },
    columns: {
      user: ["Full name", "Email", "Message", "Date"],
      employer: ["Service", "Message", "Date"],
      candidate: ["Full name", "Email", "Phone", "Education", "Skills", "Date"],
    },
    all: "All",
    title: "Requests",
    panel: "Panel",
    user: "User",
    category: "Category",
    detail: "Details",
    noData: "No data found.",
    fields: {
      name: "Name",
      email: "Email",
      message: "Message",
      createdAt: "Date",
      service: "Service",
      fullName: "Full name",
      phone: "Phone",
      education: "Education",
      skills: "Skills",
    },
    rowsPerPage: "Rows per page",
    openDetails: "▼ Show details",
    closeDetails: "▲ Hide details",
  },
  footer: {
    desc: "Ethical, solution-oriented and innovative human resources consulting.",
    rights: "All rights reserved.",
    contact: "Contact",
    tech: "OnHuman Technology",
    principles: "Working Principles",
    backToTop: "Back to Top",
  },
};
export default en;
